<div class="menu-info" *transloco="let i18n">
    @if (role() === UserRoles.Trader || role() === UserRoles.Operator) {
        <div class="menu-info-trader">
            <div class="menu-info-trader__toggles">
                <lib-payin-payout-switching (toggleSwitched)="toggleSwitchedHandler()"></lib-payin-payout-switching>
            </div>
            @if (rates()) {
                <div class="menu-info-trader__finance-title">{{ i18n('app.App.SideMenu.CourseTitle') }}</div>
                <div class="menu-info-trader__finance">
                    @for (rate of ratesToShow(); track rate.currency) {
                        <div class="menu-info-trader__finance-item">
                            <div class="menu-info-trader__finance-value">
                                {{ rate.value }}
                            </div>
                            <div class="menu-info-trader__finance-currency">
                                {{ i18n('common.Common.Currency', { currency: rate.currency }) }}
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
